import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  key: 1
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  key: 1,
  class: "option-input-group"
};
const _hoisted_4 = {
  key: 0,
  class: "option-tags"
};
const _hoisted_5 = {
  class: "dialog-footer"
};
import { addDict, addDictCategory, deleteDict, getDictListById, updateDictCategory } from "@/service/modules/dict";
import { ref, watch, computed } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
export default /*@__PURE__*/_defineComponent({
  __name: 'dict-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dialogType: {
      type: String,
      default: "add"
    },
    dictData: {
      type: Object,
      default: () => ({
        name: "",
        options: []
      })
    }
  },
  emits: ["close-dialog"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const form = ref({
      name: "",
      options: []
    });
    const isAddingOption = ref(false);
    const newOption = ref("");
    const optionList = ref([]);
    const searchQuery = ref("");
    const showAddOption = () => {
      isAddingOption.value = true;
    };
    const handleAddOption = async () => {
      if (newOption.value.trim()) {
        // optionList.value.push({
        //   id: Date.now(), // 使用时间戳作为临时ID
        //   name: newOption.value.trim(),
        // });
        try {
          let res = await addDict({
            categoryId: props.dictData.id,
            name: newOption.value.trim()
          });
          ElMessage.success("添加成功");
          getDictList();
        } catch (error) {
          console.log(error);
        }
        newOption.value = "";
        isAddingOption.value = false;
      }
    };
    const removeOption = async item => {
      // optionList.value.splice(index, 1);
      //删除二次确认
      ElMessageBox.confirm("确定要删除该选择项，删除后历史健康档案中仍保留，后续将不可被选择！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(async () => {
        try {
          let res = await deleteDict(item.id);
          ElMessage.success("删除成功");
          getDictList();
        } catch (error) {
          console.log(error);
        }
      });
    };
    const getDictList = async () => {
      try {
        let res = await getDictListById(props.dictData.id);
        console.log(123, res);
        optionList.value = res.data || [];
        form.value.options = optionList.value;
      } catch (error) {
        console.log(error);
      }
    };
    // 过滤后的选项列表
    const filteredOptions = computed(() => {
      if (!searchQuery.value) return optionList.value;
      return optionList.value.filter(item => item.name.toLowerCase().includes(searchQuery.value.toLowerCase()));
    });
    // 获取选项在原始列表中的索引
    const getOriginalIndex = item => {
      return optionList.value.findIndex(opt => opt.id === item.id);
    };
    const handleSearch = () => {
      // 搜索功能通过计算属性自动实现
    };
    watch(() => props.dialogVisible, newVal => {
      if (newVal && (props.dialogType === "edit" || props.dialogType === "options")) {
        getDictList();
        form.value = {
          name: props.dictData.name || "",
          // options: props.dictData.options || [],
          id: props.dictData.id
        };
        // optionList.value = [...(props.dictData.options || [])];
      }
    });
    function resetForm() {
      form.value = {
        name: "",
        options: []
      };
      optionList.value = [];
      isAddingOption.value = false;
      newOption.value = "";
      searchQuery.value = ""; // 重置搜索框
    }
    const handleClose = () => {
      resetForm();
      emit("close-dialog");
    };
    const handleSubmit = async () => {
      try {
        form.value.options = optionList.value;
        console.log(123, "提交的表单数据:", form.value);
        if (props.dialogType === "add") {
          let res = await addDictCategory(form.value);
          ElMessage.success("添加成功");
        } else if (props.dialogType === "edit") {
          let res = await updateDictCategory(form.value);
          ElMessage.success("修改成功");
        } else if (props.dialogType === "options") {
          // let res = await updateDict(form.value);
          // ElMessage.success("修改成功");
        }
        handleClose();
      } catch {} finally {}
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: __props.dialogType === 'add' ? '新增字典' : '编辑字典',
        "model-value": __props.dialogVisible,
        width: "500px",
        onClose: handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_5, [_createVNode(_component_el_button, {
          onClick: handleClose
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("确定")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form.value,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [__props.dialogType !== 'options' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "字段名称"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.name = $event),
              placeholder: "请输入字段名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          })) : _createCommentVNode("", true), __props.dialogType === 'options' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form_item, {
            label: "选择项"
          }, {
            default: _withCtx(() => [!isAddingOption.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_button, {
              onClick: showAddOption
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("添加选择项")])),
              _: 1
            })])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_input, {
              modelValue: newOption.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => newOption.value = $event),
              placeholder: "请输入选择项",
              onKeyup: _withKeys(handleAddOption, ["enter"])
            }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
              type: "primary",
              onClick: handleAddOption
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("确定")])),
              _: 1
            })]))]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "搜索"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: searchQuery.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => searchQuery.value = $event),
              placeholder: "请输入搜索内容",
              style: {
                "width": "70%"
              },
              onInput: handleSearch,
              clearable: ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), optionList.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, item => {
            return _openBlock(), _createBlock(_component_el_tag, {
              key: item.id,
              closable: "",
              onClose: $event => removeOption(item),
              class: "option-tag"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
              _: 2
            }, 1032, ["onClose"]);
          }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["title", "model-value"]);
    };
  }
});